import clsx from 'clsx';
import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { CountUp } from './CountUp.tsx';

interface Props {
  label: string;
  /** Static display value. Ignored when `count` is provided. */
  value?: string | number;
  /** When set, the value animates via <CountUp>. Use prefix/suffix for units. */
  count?: number;
  countPrefix?: string;
  countSuffix?: string;
  countDecimals?: number;
  countLocale?: boolean;
  sub?: string;
  tone?: 'default' | 'ok' | 'warn' | 'danger';
  icon?: LucideIcon;
  /** Optional element rendered beside the value (e.g. a sparkline). */
  accessory?: ReactNode;
}

export function KPI({
  label,
  value,
  count,
  countPrefix,
  countSuffix,
  countDecimals = 0,
  countLocale = false,
  sub,
  tone = 'default',
  icon: Icon,
  accessory,
}: Props) {
  return (
    <div className={clsx('kpi', tone !== 'default' && tone)}>
      <div className="row">
        <div className="label">{label}</div>
        <div className="spacer" />
        {Icon && <Icon size={16} className="muted" aria-hidden />}
      </div>
      <div className="row kpi-value-row">
        <div className="value">
          {count !== undefined ? (
            <CountUp
              value={count}
              prefix={countPrefix}
              suffix={countSuffix}
              decimals={countDecimals}
              locale={countLocale}
            />
          ) : (
            value
          )}
        </div>
        {accessory && <div className="kpi-accessory">{accessory}</div>}
      </div>
      {sub && <div className="sub">{sub}</div>}
    </div>
  );
}
